import { createFileRoute } from '@tanstack/react-router'
import { MagicLoginPage } from '@/features/auth/components/MagicLoginPage'

export const Route = createFileRoute('/magic-login')({
  validateSearch: (search: Record<string, unknown>): { token?: string; redirect?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  component: MagicLoginRoute,
})

// eslint-disable-next-line react-refresh/only-export-components
function MagicLoginRoute() {
  return <MagicLoginPage {...Route.useSearch()} />
}
